import { getRandomUid } from 'utilities/uuid.service';

function RadioBox({ labelProps = {}, inputProps = {}, parentProps = {} }) {
  const { label = ' Radio label', ...rest } = labelProps;
  const { id, ...props } = inputProps;

  const RadioID = id ?? getRandomUid();

  return (
    <span className="radioBlock" {...parentProps}>
      <input type="radio" id={RadioID} {...props} />
      <label htmlFor={RadioID} {...inputProps} {...rest}>
        {label}
      </label>
    </span>
  );
}

export default RadioBox;
